import { Component, OnInit, OnChanges, Input, SimpleChanges, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { CUtilForme } from 'src/app/classes/info-forme';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'arma-repartition',
  templateUrl: './arma-repartition.component.html',
  styleUrls: ['./arma-repartition.component.css']
})
export class ArmaRepartitionComponent implements OnInit, OnChanges {

// PLus bas: les parametres possibles a passer au selector
  //////////////////////////////////////////////////////////
  @Input() public width: number = 250;  // En pixel
  @Input() public height: number = 100; // En pixel
  // Important, dans le cas ou l'on souhaite utiliser plusieurs fois le composant, pour eviter d'avoir deux fois le même id dans une seule page on peut prefixer depuis le composant parrent l'id
  @Input('id') public prefixId: string | undefined;
  // Pour le décorticage avec un banana case pour le double binding, permet de maj les cotes calculer depuis le serveur rest
  @Input('Repartition') mRepartition: string; // Contiens les valeurs associé au input dans le html // Correspond au valeurs des cotations

  // Evenement de retour
  // Permet de remonter les differente information du selector sur le composant parent
  ////////////////////////////////////////////////////////////////////////////////////

  @Output() public InputFocus = new EventEmitter<FocusEvent>(); // Remonte la cote que l'on a focus

  @ViewChild('armaRepartitionCanvas', {static: true}) mCanvas!: ElementRef<HTMLCanvasElement>; // Ref au canvas dans l'html

  constructor() {
    this.mRepartition = '';
  }

  ngOnInit(): void {
    // On retourne un avertisement si l'on na pas définit l'id du selector
    if (this.prefixId === undefined) {
      //this.prefixId = (Math.floor(Math.random() * (5000 - 0)) + 0).toString();
      console.warn('selector \'id\' must be set', this.prefixId);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Recharge l'affichage de la forme si l'on modifie la taille ou le code forme
    this.reloadRepartition();
  }

  // Appelé quand on change la taille du div contenant la zone de dessins (canvas)
  // Nécessite le package angular-resize-event
  onResize() {
    const canvas: HTMLCanvasElement = this.mCanvas.nativeElement;
    const canvasStyle = getComputedStyle(canvas);
    // Si la largeur du canvas a changée on affecte la nouvelle largeur + re-dessine
    if (canvas.width != parseInt(canvasStyle.width, 10)) {
      canvas.width = parseInt(canvasStyle.width, 10);
      this.reloadRepartition();
    }
  }

  public static drawRepartitionInCanvas(canvas: HTMLCanvasElement, listLengths: string[]) {
    const ctx = canvas.getContext('2d');
    if (!ctx)
      return;
    CUtilForme.clearCanvas(canvas);
    ctx.beginPath();
    ctx.fillStyle = 'black';
    ctx.font = '20px Arial';
    ctx.textAlign = 'center';
    // Taille de la zone de dessin
    const width: number = canvas.width;
    const height: number = canvas.height;
    // Marge des bords gauche et droit
    const margin = 20;
    // Hauteur des graduations pour chaque filant
    const markHeight = 8;
    // Hauteur des graduations dans une multiplication
    const markHeightMult = 4;
    // Milieu vertical de la zone de dessin
    const heightCenter: number = height / 2;
    let nbCadres = 0;
    let totalLength = 0;
    // Dessin de la ligne de répartition
    ctx.moveTo(margin, heightCenter);
    ctx.lineTo(width - margin, heightCenter);
    ctx.stroke();
    // Calcul de la longueur totale
    listLengths.forEach(length => {
      if (length.length > 0) {
        const multiplication: string[] = length.split('*');
        // Calcul de la longueur totale de la multiplication si s'en est une
        if (multiplication.length > 1) {
          const multiplier: number = parseInt(multiplication[0], 10);
          const multiple: number = parseInt(multiplication[1], 10);
          if (!(isNaN(multiplier) || isNaN(multiple)))
          totalLength += parseInt(multiplication[0], 10) * parseInt(multiplication[1], 10);
        } else {
          const lengthNum: number = parseInt(length, 10);
          if (!isNaN(lengthNum))
            totalLength += parseInt(length, 10);
        }
      }
    });
    const lengthToPx: number = totalLength / (width - (2 * margin));
    let XPos = 0;           // Offset horizontal
    let textAbove = true; // Afficher le texte au dessus (true) ou en dessous (false) de la ligne de répartition
    // Dessin des marques de répartition
    for (let i = 0 ; i < listLengths.length; i++) {
      // Si la ligne n'est pas vide
      if (listLengths[i].length > 0) {
        const multiplication: string[] = listLengths[i].split('*');
        let length: number;
        let positionX: number;
        const beginX: number = XPos;
        let lengthText: string;
        //Si c'est une multiplication
        if (multiplication.length > 1) {
          length = parseInt(multiplication[1], 10);
          // Dessin des graduations pour chaque filant de la multiplication
          ctx.beginPath();
          ctx.lineWidth = 0.5;
          for (let y = 0 ; y < parseInt(multiplication[0], 10) ; y++) {
            if (y != multiplication.length - 1) {
              ctx.moveTo(margin + ((XPos + length) / lengthToPx), heightCenter - markHeightMult);
              ctx.lineTo(margin + ((XPos + length) / lengthToPx), heightCenter + markHeightMult);
              nbCadres++;
              XPos += length;
            }
          }
          ctx.stroke();
          lengthText = listLengths[i].toString();
        } else {
          length = parseInt(listLengths[i], 10);
          lengthText = length.toString();
        }
        XPos += length;
        // Dessin du texte de longueur répart
        positionX = margin + ((beginX + XPos) / 2) / lengthToPx;
        ctx.fillText(lengthText, positionX, heightCenter + 2.5 * (textAbove ? -markHeight : markHeight) + markHeight);
        textAbove = !textAbove;
      }
      // Dessin des grandes marques
      if (i != listLengths.length - 1) {
        ctx.beginPath();
        ctx.lineWidth = 2;
        ctx.moveTo(margin + ((XPos + length) / lengthToPx), heightCenter - markHeight);
        ctx.lineTo(margin + ((XPos + length) / lengthToPx), heightCenter + markHeight);
        ctx.stroke();
        nbCadres++;
      }
    }
    // Infos sur la répartition
    ctx.font = '14px Arial';
    ctx.textAlign = 'left';
    ctx.fillText('Longueur : ' + totalLength.toString(), margin, height - 10);
    ctx.fillText('Cadres : ' + Math.max(0, nbCadres).toString(), width / 2, height - 10);
  }

  reloadRepartition() {
    // Utilisation de la fonction qui permet de dessiné la répartition
    const listRepart: string[] = this.mRepartition.split('/');
    ArmaRepartitionComponent.drawRepartitionInCanvas(this.mCanvas.nativeElement, listRepart);
  }

  onInputFocus(event: FocusEvent) {
    this.InputFocus.emit(event);
  }

}
